import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { ExchangeAntimalwareExclusionFormValue } from '../../../../../../utils/uiSettings/exchange/exchange-protection.types';
import { ExchangeAntimalwareExclusionRule } from '@nirvana/shared/dtos/types/policies/common';

// validate duplicates
export function validateDuplicates(
  ruleItem: ExchangeAntimalwareExclusionFormValue,
  rulesInGrid: ExchangeAntimalwareExclusionRule[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some(
    (ruleInGrid: ExchangeAntimalwareExclusionRule) => ruleInGrid.name === ruleItem.name
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
